import get from 'lodash/get';
import { useQuery } from '@sde/widgets-core/src/tools/useQuery';
import GET_TERMS_OF_USE_QUERY from './GetTermsOfUse.gql';

const parseResult = (result) => {
  const initialState = {
    accepted: false,
  };

  const termsOfUse = get(result, 'core.getTermsOfUseStatus');

  return {
    ...initialState,
    ...termsOfUse,
  };
};

export const useGetTermsOfUseQuery = (options) => {
  const [queryResult, queryAction] = useQuery(GET_TERMS_OF_USE_QUERY, {
    ...options,
    requestPolicy: 'no-cache',
    onCompleted: (result) => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
